import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=a4bd8e12&scoped=true&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"
import style0 from "./Theme.vue?vue&type=style&index=0&id=a4bd8e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bd8e12",
  null
  
)

export default component.exports